export const tools = [
  {
    id: 1,
    iconClass: "icon-chart-network",
    title: "Immersive VR Training",
    description:
      "Dive into an engaging learning experience.",
    order: "01",
    delay: "0s",
  },
  {
    id: 2,
    iconClass: "icon-device",
    title: "Cross-Platform Access",
    description:
      "Train across all your devices with ease.",
    order: "02",
    delay: "0.2s",
  },
  {
    id: 3,
    iconClass: "icon-alarm-clock",
    title: "Real-Time Tracking",
    description:
      "Monitor attendance, progress, and evaluation in real time.",
    order: "03",
    delay: "0s",
  },
  {
    id: 4,
    iconClass: "icon-maintenance",
    title: "Customize Your Learning Path",
    description:
      "Tailor your training experience based on your career goals and interests.",
    order: "04",
    delay: "0.2s",
  },
  {
    id: 5,
    iconClass: "icon-setting",
    title: "Comprehensive Tools",
    description:
      "Manage course planning, certification, and skill assessments all in one place.",
    order: "05",
    delay: "0s",
  },
  {
    id: 6,
    iconClass: "icon-toolbox",
    title: "Repurpose Your Knowledge",
    description:
      "Apply the skills you gain across various roles and industries, enhancing your career versatility.",
    order: "06",
    delay: "0.2s",
  },
];

export const tools2 = [
  {
    id: 1,
    icon: "icon-folders",
    title: "AI Copyrighting",
    description:
      "Must explain to you how all this mistaken idea seen denouncing pleasure",
    order: "01",
    delay: "0s",
  },
  {
    id: 2,
    icon: "icon-code",
    title: "Coding Assistant",
    description:
      "Must explain to you how all this mistaken idea seen denouncing pleasure",
    order: "02",
    delay: "0.1s",
  },
  {
    id: 3,
    icon: "icon-images",
    title: "Image Generator",
    description:
      "Must explain to you how all this mistaken idea seen denouncing pleasure",
    order: "03",
    delay: "0.2s",
  },
  {
    id: 4,
    icon: "icon-chart-network",
    title: "AI Social Media",
    description:
      "Must explain to you how all this mistaken idea seen denouncing pleasure",
    order: "04",
    delay: "0.3s",
  },
];
export const tools3 = [
  {
    id: 1,
    icon: "icon-folder",
    title: "Blog Post & Articles",
    description:
      "Must explain to you how all this mistaken idea seen denouncing pleasure and praising",
    order: "01",
  },
  {
    id: 2,
    icon: "icon-email",
    title: "Social Media Ads",
    description:
      "Must explain to you how all this mistaken idea seen denouncing pleasure and praising",
    order: "02",
  },
  {
    id: 3,
    icon: "icon-gif",
    title: "eCommerce Copy",
    description:
      "Must explain to you how all this mistaken idea seen denouncing pleasure and praising",
    order: "03",
  },
  {
    id: 4,
    icon: "icon-device",
    title: "Website Copy",
    description:
      "Must explain to you how all this mistaken idea seen denouncing pleasure and praising",
    order: "04",
  },
  {
    id: 5,
    icon: "icon-diamon",
    title: "Digital Add Copy",
    description:
      "Must explain to you how all this mistaken idea seen denouncing pleasure and praising",
    order: "05",
  },
  {
    id: 6,
    icon: "icon-cart",
    title: "Buy & Sales Copy",
    description:
      "Must explain to you how all this mistaken idea seen denouncing pleasure and praising",
    order: "06",
  },
];
